import { Fragment } from 'react';
import { PageHeader } from '@/deploy/components/layout/PageHeader';
import { EnvBadge } from '@/deploy/components/ui/EnvBadge';
import { MongoExplorer } from '@/deploy/components/deploy/MongoExplorer';
import { useSessionStore } from '@/deploy/stores/session.store';
import { useDeployEnvStore } from '@/deploy/stores/deployEnv.store';
import type { ApiEnvId } from '@/deploy/services/api-pterodactyl-config.service';
import { API_ENV_GROUPS, API_ENV_LABELS, apiEnvGroup } from '@/deploy/utils/apiEnvs';
import styles from './ApiServices.module.scss';

export function Database() {
  const project = useSessionStore((s) => s.currentProject());
  const envId = useDeployEnvStore((s) => s.env) as ApiEnvId;
  const setEnvId = useDeployEnvStore((s) => s.setEnv);

  return (
    <div className={styles.page}>
      <PageHeader
        eyebrow="Base de données"
        title="Explorateur MongoDB"
        subtitle="Parcours les bases, collections et documents du service Mongo de chaque environnement (prod en lecture seule)."
      />

      {/* Même rendu soudé que la page APIs : le MongoDB est une API, partagée par Dev et Bêta. */}
      <nav className={styles.tabs}>
        {API_ENV_GROUPS.map((g) => {
          const members = apiEnvGroup(g);
          const active = members.includes(envId);
          const tab = (e: ApiEnvId) => (
            <button
              key={e}
              type="button"
              className={[styles.tab, active && members.length === 1 && styles.tabActive].filter(Boolean).join(' ')}
              onClick={() => setEnvId(e)}
            >
              <EnvBadge env={e} size="sm" />
              <span>{API_ENV_LABELS[e]}</span>
            </button>
          );
          if (members.length === 1) return tab(g);
          return (
            <div
              key={g}
              className={[styles.tabLinked, active && styles.tabLinkedActive].filter(Boolean).join(' ')}
              title="Dev et Bêta partagent le même MongoDB"
            >
              {members.map((e, i) => (
                <Fragment key={e}>
                  {i > 0 && <span className={styles.tabJoin} aria-hidden>+</span>}
                  {tab(e)}
                </Fragment>
              ))}
            </div>
          );
        })}
      </nav>
      {apiEnvGroup(envId).length > 1 && (
        <div className={styles.fieldHint}>
          Dev et Bêta partagent le même MongoDB : une modification faite ici vaut pour les deux.
        </div>
      )}

      {/* key={envId} → l'explorateur repart d'un état propre à chaque changement d'env. */}
      <MongoExplorer key={envId} projectId={project.id} env={envId} defaultOpen />
    </div>
  );
}
